<script setup>
import { reactive, ref } from "vue";
import { useHttp } from "vutil";

const emit = defineEmits(["login"]);

const verify = ref(false);
const data = reactive({});

const { busy, error, post } = useHttp(() => {
	if (!verify.value)
		verify.value = true;
	else
		emit("login");
}, () => {
	verify.value = false;
	data.code = null;
});
</script>

<template>
	<h1>Opprett konto</h1>
	<form @submit.prevent="post('/api/user', data)">
		<fieldset :disabled="busy">
			<label for="name">Navn</label>
			<input id="name" v-model.trim="data.name" type="text" autocomplete="name" autofocus required>
			<label for="email">E-postadresse</label>
			<input id="email" v-model.trim="data.email" type="email" autocomplete="username" :readonly="verify" required>
			<label for="password">Passord</label>
			<input id="passwd" v-model="data.passwd" type="password" autocomplete="new-password" minlength="8" required>
			<template v-if="verify">
				<label for="code">Verifikasjonskode</label>
				<input id="code" v-model="data.code" type="text" autocomplete="one-time-code" required>
				<div class="ui-hint">Vi har sendt deg en verifikasjonskode på e-post.</div>
			</template>
			<div class="error">{{ error }}</div>
			<button type="submit" class="ui">{{ error ? "Prøv igjen" : verify ? "Verifiser" : "Videre" }}</button>
		</fieldset>
	</form>
	<p>Ved å registrere deg godtar du <a href="/agreement" target="_blank">Leverandøravtalen</a>.</p>
</template>
